(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5300],{

/***/ 82516:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vioc-ES",
      function () {
        return __webpack_require__(7676);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ViocPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43568);
/* harmony import */ var _components_ViocPage_viocCopy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82011);
/* harmony import */ var _components_utils_string_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2638);
/* harmony import */ var _components_SEMPage_CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21611);





var ViocEsPage = function(param) {
    var _rating = param.rating, rating = _rating === void 0 ? "4.94" : _rating, _reviewCount = param.reviewCount, reviewCount = _reviewCount === void 0 ? 6013 : _reviewCount;
    var phoneNumber = _components_SEMPage_CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData.generalValvoline.phoneNumber */ .L.generalValvoline.phoneNumber;
    var phoneNumberTxt = (0,_components_utils_string_utils__WEBPACK_IMPORTED_MODULE_4__/* .formatPhoneNumber */ .u)(phoneNumber);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ViocPage__WEBPACK_IMPORTED_MODULE_1__/* .ViocIndexPageTemplate */ .S, {
        copy: (0,_components_ViocPage_viocCopy__WEBPACK_IMPORTED_MODULE_2__/* .getViocCopy */ .ak)("es"),
        rating: rating,
        reviewCount: reviewCount,
        phoneNumberTxt: phoneNumberTxt,
        phoneNumber: phoneNumber
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ViocEsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2978,4231,7858,4024,7533,2932,6566,6263,3568,9774,2888,179], function() { return __webpack_exec__(82516); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);